import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="region-london"
export default class extends Controller {

  static targets = ['label']

  connect() {
    this.london();
    this.textReplaceLoad();
    this.textReplaceChange();
  }

  london() {
    let ldnAll = this.element.querySelector('.london-all')
    let ldnSingles = this.element.querySelectorAll('.london-single')

    ldnAll.addEventListener('change', () => {
      if(ldnAll.checked == true){
        ldnSingles.forEach(e => {
          e.checked = true;
        })
      } else if(ldnAll.checked == false){
        ldnSingles.forEach(e => {
          e.checked = false;
        })
      }
    })

    ldnSingles.forEach(e => {
      e.addEventListener('change', () => {
        const ldnChecked = [...ldnSingles].every(input => input.checked == true);
        if(ldnChecked){
          ldnAll.checked = true;
        } else if(!ldnChecked){
          ldnAll.checked = false;
        }
      })
    });

  }

  textReplaceLoad() {
    let londonLabels = [...this.element.querySelectorAll('label:has(input[data-london=true])')];
    let otherLabels = [...this.element.querySelectorAll('label:has(input[data-london=false])')];
    let otherLabelsChecked = [];
    let londonLabelsChecked = [];

    otherLabels.forEach(e => { // This finds all the ticked non-London checkboxes and puts them into an array
      if(e.querySelector('input').checked == true){
        otherLabelsChecked.push(e); 
      }
    });

    londonLabels.forEach(e => { // This finds all the ticked London checkboxes and puts them into an array
      if(e.querySelector('input').checked == true){
        londonLabelsChecked.push(e);
      }
    });  

    const londonChecked = londonLabels.some(label => label.querySelector('input').checked == true); // Returns TRUE if ANY London checkbox is checked
    const otherChecked = otherLabels.some(label => label.querySelector('input').checked == true); // Returns TRUE if ANY other checkboxes are checked

    if(londonChecked && otherChecked){
      this.labelTarget.innerText = "Multiple"
    }    
    else if(!londonChecked && otherChecked){
      if(otherLabelsChecked.length == 1){
        this.labelTarget.innerText = otherLabelsChecked[0].innerText
      } 
      else if(otherLabelsChecked.length > 1){
        this.labelTarget.innerText = "Multiple"
      }  
    }
    else if (londonChecked && !otherChecked){
      if(londonLabelsChecked.length == 1){
        this.labelTarget.innerText = londonLabelsChecked[0].innerText
      }
      else if(londonLabelsChecked.length > 1){
        this.labelTarget.innerText = 'London';
      }
    }
    else if (!londonChecked && !otherChecked){
      this.labelTarget.innerText = 'Any';
    }
  }

  textReplaceChange() {
    let checkboxes = this.element.querySelectorAll('input[type=checkbox]');    
    checkboxes.forEach(box => {
      box.addEventListener('change', () => {
        this.textReplaceLoad();
      });
    });
  }
}
